import { Component, EventEmitter, Input, Output, ViewEncapsulation } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { CommonModule } from '@angular/common';

@Component({
	selector: 'nha-chip',
	templateUrl: './chip.component.html',
	styleUrls: ['./chip.component.scss'],
	encapsulation: ViewEncapsulation.None,
	imports: [CommonModule, MatIconModule]
})
export class NHAChipComponent {
	@Input() text: string;
	@Input() icon: string;
	@Input() color: 'red' | 'yellow' | 'green' | 'blue' | 'gray' | 'orange' | 'clear' | 'medium-blue' | 'dark-blue' | 'white' | 'light-red' | 'purple' = 'gray';
	@Input() iconSize: string = '24px';
	@Input() hover: boolean = false;

	@Output() clicked: EventEmitter<Event> = new EventEmitter<Event>();

	onChipClicked(event: Event): void {
		this.clicked.emit(event);
	}
}
